namespace JupitersChoice {
    export class SkipPaylinesButton extends Sapphire.Button {

        @inject('AssetCache') _assetCache: Sapphire.AssetCache;
        @inject('StateModel') _stateModel: Sapphire.StateModel;

        private _data: Sapphire.DataHelper;

        constructor() {
            super();
        }

        construct(data: any) {
            super.construct(data, this._assetCache);
            this._data = new Sapphire.DataHelper(data);
        }

        setOrientation(orientation: string): void {
            this._data.orientation = orientation;
            this.updateLayout();
        }

        private updateLayout() {
            this.x = this._data.get('x', this.x);
            this.y = this._data.get('y', this.y);

            const scale = this._data.get('scale', { x: 1, y: 1 });
            this.scale.set(scale.x, scale.y);

            if (this._stateModel.currentSubgame === 'FreeGame' && this._data.orientation === 'portrait') {
                this.x -= 244;
                this.y -= 30;
                this.scale.set(1, 1);
            }
        }
    }
}